import { z, ZodType } from 'zod';
import { CSSTextAlignType, cssTextAlignTypeSchema, WidgetsName, WidgetType } from './common';
import { zObject } from '../../util/zod';

export type WidgetArticleTitleContent = {
    text?: string;
    textAlign?: CSSTextAlignType;
    heading?: string;
    color?: string;
    backgroundColor?: string;
    dataCy?: string;
};
export const widgetArticleTitleContentSchema = zObject<WidgetArticleTitleContent>({
    text: z.string().optional(),
    textAlign: cssTextAlignTypeSchema.optional(),
    heading: z.string().optional(),
    color: z.string().optional(),
    backgroundColor: z.string().optional(),
    dataCy: z.string().optional(),
});

export type WidgetArticleTitleType = {
    name: WidgetsName.ArticleTitle;
    uniqid: string;
    content: WidgetArticleTitleContent;
};
export const widgetArticleTitleTypeSchema = zObject<WidgetArticleTitleType>({
    name: z.literal(WidgetsName.ArticleTitle),
    uniqid: z.string(),
    content: widgetArticleTitleContentSchema,
}) satisfies ZodType<WidgetType<WidgetArticleTitleContent>>;
